import { Component } from '@angular/core';

import { PortalApiService } from '../../portal-api.service';
import { PortalBrandingService } from '../../portal-branding.service';

@Component({
	selector: 'portal-forgot-password',
	templateUrl: './forgot-password.component.html',
	styleUrls: ['../login/login.component.scss']
})
export class ForgotPasswordComponent {

	email = '';
	sent = false;
	loading = false;
	error = '';

	constructor(
		private api: PortalApiService,
		public branding: PortalBrandingService
	) {}

	get companyInitial(): string { return (this.branding.companyName || '?').trim().charAt(0).toUpperCase(); }
	get coverUrl(): string | null { return this.branding.loginCoverUrl; }

	submit(): void {
		this.error = '';
		if (!this.email.trim()) { this.error = 'Please enter your email address.'; return; }

		this.loading = true;
		this.api.auth.requestReset({ email: this.email.trim() }, () => {
			this.loading = false;
			this.sent = true;
		}, (err: any) => {
			this.loading = false;
			this.error = err?.message || 'We could not send the reset link. Please try again.';
		});
	}
}
